export default "__VITE_ASSET__BXhtLpyc__"